/**
 * 年度预算编制
 * chenxiaojian 2020-02-14
 */
import React from 'react';

import { Row, Col, Empty, Card, DatePicker, Table, Statistic, Progress, Button } from 'antd';
import moment from 'moment';

import http from '../../../axios/http';

import { fixedNumber } from '../../../util/util';
//加载中遮罩
import Loading from '../../ui/Loading';

class WeekWriteIndex extends React.Component {

    //统计信息的数据
    statisticFields = [{
        "field": "hasStaff",
        "text": "在职编制人数",
    }, {
        "field": "hasEpiboly",
        "text": "在职外包人数",
    }, {
        "field": "budgetStaff",
        "text": "预算编制人数",
    }, {
        "field": "budgetEpiboly",
        "text": "预算外包人数",
    }, {
        "field": "addStaff",
        "text": "入职编制人数",
    }, {
        "field": "minusStaff",
        "text": "离职编制人数",
    }, {
        "field": "addEpiboly",
        "text": "入职外包人数",
    }, {
        "field": "minusEpiboly",
        "text": "离职外包人数",
    }];

    businessColumns = [{
        title: '部门',
        dataIndex: 'orgName',
        width: '10%',
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row["orgLength"]
                },
            };
        },
    }, {
        title: '项目',
        dataIndex: 'itemName',
        width: '15%',
        colSpan: 2,
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row["rowSpan"],
                    colSpan: row["colSpan"] != null ? row["colSpan"] : 1
                },
            };
        },
    }, {
        title: '分项',
        dataIndex: 'subName',
        width: '10%',
        colSpan: 0,
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    colSpan: row["colSpan"] != null ? 0 : 1
                },
            };
        },
    }, {
        title: '本周执行',
        dataIndex: 'week',
        width: '15%',
    }, {
        title: '本月累计执行',
        dataIndex: 'month',
        width: '15%',
    }, {
        title: '年度预算目标',
        dataIndex: 'yearBudget',
        width: '15%',
    }, {
        title: '年度累计执行',
        dataIndex: 'year',
        width: '15%',
    }, {
        title: '年度执行进度',
        dataIndex: 'reportId',
        width: '15%',
        render: (text, record, index) => {
            return <Progress percent={fixedNumber((record["year"] / record["yearBudget"] * 100).toFixed(2), 2)} />;
        }
    }];

    activityColumns = [{
        title: '活动名称',
        dataIndex: 'name',
        width: '10%'
    }, {
        title: '活动类型',
        dataIndex: 'type',
        width: '10%',

    }, {
        title: '活动投放',
        dataIndex: 'launch',
        width: '10%',
    }, {
        title: '活动费用',
        dataIndex: 'fees',
        width: '10%',
    }, {
        title: '活动概述',
        dataIndex: 'summary',
        width: '60%',
    }];


    workColumns = [{
        title: '部门',
        dataIndex: 'orgName',
        width: '10%',
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row["orgLength"]
                },
            };
        },
    }, {
        title: '项目',
        dataIndex: 'mainName',
        width: '15%',
        colSpan: 2,
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row["rowSpan"] != null ? row["rowSpan"] : 0
                },
            };
        },
    }, {
        title: '分项',
        dataIndex: 'itemName',
        width: '10%',
        colSpan: 0
    }, {
        title: '本周工作计划',
        dataIndex: 'thisPlan',
        width: '25%',
        onCell: () => tableTextStyle,
        render: (value, row, index) => {
            return this.string2Html(value);
        },
    }, {
        title: '本周主要工作内容',
        dataIndex: 'thisWork',
        width: '25%',
        onCell: () => tableTextStyle,
        render: (value, row, index) => {
            return this.string2Html(value);
        },
    }, {
        title: '下周工作计划',
        dataIndex: 'nextPlan',
        width: '25%',
        onCell: () => tableTextStyle,
        render: (value, row, index) => {
            return this.string2Html(value);
        },
    }];

    string2Html = (value) => {
        value = value == null ? value : value.replace(/\n/g, '<br/>');
        return <div dangerouslySetInnerHTML={{ __html: value }} />
    }

    state = {
        //查询数据
        queryData: {
            year: moment().year(),
            month: moment().format('YYYY-MM'),
        },
        data: [],   //用于页面展示渲染的数据
    };

    componentDidMount() {
        //获取已经创建了预算部门的信息
        this.loadData(this.state.queryData);
    }

    //加载数据，用于页面渲染
    loadData = (queryData) => {
        http.get({
            url: "/reportWeek/sum/findWeekReportSum",
            data: queryData,
            success: (map) => {
                let res = map["work"];
                let activity = map["activity"];
                let resultList = [];
                if (res != null && res.length > 0) {
                    let result = {};
                    for (let i = 0; i < res.length; i++) {
                        let r = result[res[i]["weekNum"]];
                        if (r == null) {
                            r = {
                                hasStaff: 0,
                                budgetStaff: 0,
                                addStaff: 0,
                                minusStaff: 0,
                                hasEpiboly: 0,
                                budgetEpiboly: 0,
                                addEpiboly: 0,
                                minusEpiboly: 0,
                                startDate: res[i]["startDate"],
                                endDate: res[i]["endDate"],
                                weekNum: res[i]["weekNum"],
                                business: [],
                                work: []
                            };
                            resultList.push(r);
                        }
                        r.hasStaff += res[i]["hasStaff"];
                        r.budgetStaff += res[i]["budgetStaff"];
                        r.addStaff += res[i]["addStaff"];
                        r.minusStaff += res[i]["minusStaff"];
                        r.hasEpiboly += res[i]["hasEpiboly"];
                        r.budgetEpiboly += res[i]["budgetEpiboly"];
                        r.addEpiboly += res[i]["addEpiboly"];
                        r.minusEpiboly += res[i]["minusEpiboly"];

                        let subNode = res[i].subNode;
                        let sumFlag = 0;
                        if (subNode != null && subNode.length > 0) {
                            let business = [];  //业务项目
                            let work = [];  //工作项目
                            let itemName = "收入合计";
                            if (res[i].orgName != null && res[i].orgName.startsWith("财务")) {
                                itemName = "经营利润";
                            }
                            let businessSum = {
                                "week": 0,
                                "month": 0,
                                "year": 0,
                                "yearBudget": 0,
                                "itemName": res[i].orgName + itemName,
                                "colSpan": 2,
                                "key": "-" + i,
                                "rowSpan": 1,
                                "orgName": subNode[0]["orgName"]
                            };
                            for (let j = 0; j < subNode.length; j++) {
                                if (subNode[j].type === 1) {
                                    let num = {
                                        "tableIndex": i,
                                        "key": "" + subNode[j]["reportId"] + "-0",
                                        "itemName": subNode[j]["itemName"],
                                        "subName": "数量",
                                        "week": subNode[j]["incomeNum"],
                                        "month": subNode[j]["monthNum"],
                                        "year": subNode[j]["yearNum"],
                                        "yearBudget": subNode[j]["numBudget"],
                                        "reportId": subNode[j]["reportId"],
                                        "orgName": subNode[j]["orgName"],
                                        "rowSpan": 2,
                                    };
                                    let money = {
                                        "tableIndex": i,
                                        "key": "" + subNode[j]["reportId"] + "-1",
                                        "itemName": subNode[j]["itemName"],
                                        "subName": "金额",
                                        "week": subNode[j]["incomeMoney"],
                                        "month": subNode[j]["monthMoney"],
                                        "year": subNode[j]["yearMoney"],
                                        "yearBudget": subNode[j]["moneyBudget"],
                                        "reportId": subNode[j]["reportId"],
                                        "orgName": subNode[j]["orgName"],
                                        "rowSpan": 0,
                                    };
                                    if (itemName === "经营利润") {
                                        //针对财务部的信息做特殊处理
                                        let factor = 1;
                                        if (subNode[j]["itemName"] === "收入") {
                                            factor = 0;
                                        } else if (subNode[j]["itemName"] === "毛利") {
                                            factor = 1;
                                        } else if (subNode[j]["itemName"] === "税金及费用") {
                                            factor = -1;
                                        }
                                        businessSum["week"] += money["week"] * factor;
                                        businessSum["month"] += money["month"] * factor;
                                        businessSum["year"] += money["year"] * factor;
                                        businessSum["yearBudget"] += money["yearBudget"] * factor;
                                    } else {
                                        businessSum["week"] += money["week"];
                                        businessSum["month"] += money["month"];
                                        businessSum["year"] += money["year"];
                                        businessSum["yearBudget"] += money["yearBudget"];
                                    }
                                    if (subNode[j]["onlyMoney"] === 1) {
                                        // money["colSpan"] = 2;
                                        money["rowSpan"] = 1;
                                    } else {
                                        business.push(num);
                                    }
                                    business.push(money);
                                    sumFlag++;
                                } else if (subNode[j].type === 2) {
                                    let s = subNode[j]["subNode"];
                                    if (s == null || s.length === 0) {
                                        subNode[j]["rowSpan"] = 1;
                                        subNode[j]["tableIndex"] = i;
                                        work.push(subNode[j]);
                                    } else {
                                        s[0]["mainName"] = subNode[j]["itemName"];
                                        s[0]["rowSpan"] = s.length;
                                        s.forEach(item => {
                                            item["tableIndex"] = i;
                                            work.push(item)
                                        });
                                    }
                                }
                            }
                            if (sumFlag > 1) {
                                business.push(businessSum);
                            }
                            if (business != null && business.length > 0) {
                                for (let t in business) {
                                    business[t]["orgLength"] = 0;
                                    r["business"].push(business[t]);
                                }
                                business[0]["orgLength"] = business.length;
                            }
                            if (work != null && work.length > 0) {
                                for (let t in work) {
                                    work[t]["orgLength"] = 0;
                                    r["work"].push(work[t]);
                                }
                                work[0]["orgLength"] = work.length;
                            }
                            result[res[i]["weekNum"]] = r;
                        }
                    }
                }
                this.setState({ data: resultList, activity: activity });
            }
        });
    }

    queryMonthStart = (date, dateString) => {
        let { queryData } = this.state;
        let newYear = date.year();
        queryData.year = newYear;
        queryData.month = date.format("YYYY-MM")
        this.setState({ queryData: queryData });
        //如果没有改变年份，则不用再加载部门数据，直接加载查询数据，否则需先加载部门数据
        this.loadData(queryData);
    }

    //操作按钮
    extra = (index) => {
        let dom = [];
        dom.push(<Button key="download" type="primary" onClick={this.download.bind(this, index)}>导出</Button>);
        return dom;
    }

    /**
     * 导出数据
     */
    download = (index) => {
        this.setState({ loadingVisible: true });
        let value = this.state.data[index];
        let activity = this.state.activity[value["weekNum"]];
        value.activity = activity;
        value.year = this.state.queryData.year;
        http.download({
            url: '/reportWeek/sum/downloadWeekReportSum',
            data: { downloadJson: JSON.stringify(value) },
            fileName: "第" + value["weekNum"] + "周周报信息.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
                <Row>
                    <Col span={24}>
                        <DatePicker.MonthPicker onChange={this.queryMonthStart} placeholder="月份" allowClear={false}
                            defaultValue={moment().startOf('month')} />
                    </Col>
                </Row>
                <Row>
                    {this.state.data == null || this.state.data.length === 0 ?
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        :
                        this.state.data.map((value, index) => {
                            return <Col span={24} style={{ margin: "10px 0" }} key={index}>
                                <Card title={"第" + value['weekNum'] + "周（" + value["startDate"] + "~" + value["endDate"] + "）"} bordered={true}
                                    extra={this.extra(index)} >
                                    <Card.Grid style={gridStyle} kye="基本信息">
                                        <Row>
                                            {this.statisticFields.map((item, subIndex) => {
                                                return <Col span={3} key={subIndex}>
                                                    <Statistic title={item.text} value={value[item.field]} />
                                                </Col>;
                                            })}
                                        </Row>
                                    </Card.Grid>
                                    <Card.Grid style={gridStyle} kye="业务指标">
                                        <Table rowKey="key" columns={this.businessColumns} dataSource={value["business"]} tableLayout="fixed" pagination={false} bordered={true} />
                                    </Card.Grid>
                                    <Card.Grid style={gridStyle} kye="市场活动">
                                        <Table rowKey="id" columns={this.activityColumns} dataSource={this.state.activity[value["weekNum"]]} tableLayout="fixed" pagination={false} bordered={true} />
                                    </Card.Grid>
                                    <Card.Grid style={gridStyle} kye="工作总结">
                                        <Table rowKey="code" columns={this.workColumns} dataSource={value["work"]} tableLayout="fixed" pagination={false} bordered={true} />
                                    </Card.Grid>
                                </Card>
                            </Col>
                        })
                    }
                </Row>
                <Loading visible={this.state.loadingVisible} message="正在处理中，请稍候..." />
            </div>
        )
    }
}

const gridStyle = {
    width: '100%',
    textAlign: 'center',
};

const tableTextStyle = {
    style: {
        overflow: 'visible',
        whiteSpace: 'normal',
    }
}

export default WeekWriteIndex;